import { DataDisplayEvent } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { LoadTenderExpress } from "./LoadTenderExpress";
import { AutogenLayoutLoadTenderExpressExpanded } from "./autogen/AutogenLayoutLoadTenderExpressExpanded";

export class LoadTenderExpressExpanded extends AutogenLayoutLoadTenderExpressExpanded {
    private _tenderID: string;
    private _purposeType: String;
    private _orderID: String;
    private _templateType: String;
    private _replyCreated: string;
    private _loadTenderExpress: LoadTenderExpress;

    override onLoad() {
        this.tenderID = this.tenderID;
        this.purposeType = this.purposeType;
        this.orderID = this.orderID;
        this._loadTenderExpress = this.loadTenderExpress;
        this.initialize();
    }

    initialize() {
        if (!StringUtil.isEmptyString(this.tenderID)) {
            this.sourceEdiOrder.search({ id: this.tenderID });
            this.sourceEdiStop.search({ order_id: this.tenderID });
        }
    }

    get tenderID(): string {
        return this._tenderID;
    }

    set tenderID(value: string) {
        this._tenderID = value;
    }

    set purposeType(value: String) {
        this._purposeType = value;
    }

    get purposeType(): String {
        return this._purposeType;
    }

    get orderID(): String {
        return this._orderID;
    }

    set orderID(value: String) {
        this._orderID = value;
    }

    get templateType(): String {
        return this._templateType;
    }

    set templateType(value: String) {
        this._templateType = value;
    }

    set loadTenderExpress(value: LoadTenderExpress) {
        this._loadTenderExpress = value;
    }

    get loadTenderExpress() {
        return this._loadTenderExpress;
    }

    get replyCreated(): string {
        return this._replyCreated;
    }

    set replyCreated(value: string) {
        this._replyCreated = value;
    }

    sourceEdiOrderOnDisplay(event: DataDisplayEvent) {
        const movementStatus = event.rowData?.get("movement.status");
        const isBrokerage = event.rowData?.get("movement.brokerage");
        const brokerageStatusColor = event.rowData?.get("brokerage_status_color");
        if (this.purposeType === "Original" || !this.orderID) {
            this.labelMoveStatus.visible = false;
            this.panelBrkStatus.visible = false;
        }
        else if (isBrokerage === "N" || isBrokerage == "") this.panelBrkStatus.visible = false;
        else this.setPanelBrokerageStatusColor(brokerageStatusColor);

        if (this.labelMoveStatus.visible) {
            switch (movementStatus) {
                case "A":
                    event.rowData?.set("move_status", "Available");
                    break;
                case "C":
                    event.rowData?.set("move_status", "Covered");
                    break;
                case "D":
                    event.rowData?.set("move_status", "Delivered");
                    break;
                case "P":
                    event.rowData?.set("move_status", "In Progress");
                    break;
                case "V":
                    event.rowData?.set("move_status", "Void");
                    break;
                default:
                    this.labelMoveStatus.text = "Other";
                    break;
            }
        }
        const preloaded = event.rowData?.get("preloaded") as string;
        if (preloaded === "Yes" || preloaded === "Y") {
            this.labelPreloadedLabel.text = "Y";
        } else {
            this.labelPreloadedLabel.text = "N";
        }
    }

    setPanelBrokerageStatusColor(color: any) {
        if (color == null || color == "#ffffff") {
            this.panelBrkStatus.backgroundColor = "default.reverse";
            this.panelBrkStatus.color = "default";
            this.panelBrkStatus.borderColor = "default";
            this.panelBrkStatus.borderWidth = 1;
        }
        else {
            this.panelBrkStatus.backgroundColor = color;
            this.panelBrkStatus.color = "default.reverse";
            this.panelBrkStatus.borderColor = null;
            this.panelBrkStatus.borderWidth = null;
        }
    }

}
